export enum ResourceType {
    Deployment = 'deployment',
    Statefulset = 'statefulset',
}

export class Helm {
    commit: string;
    branch: string;
    repository: string;
    diff: Map<string, number>;

    constructor() {
        this.commit = '';
        this.branch = '';
        this.repository = '';
        this.diff = new Map<string, number>();
    }
}

export class Deploy {
    job: string | undefined;
    commit: string;
    branch: string | undefined;
    repository: string | undefined;
    date: Date | undefined;
    diff: Map<string, number>;

    constructor() {
        this.job = '';
        this.commit = '';
        this.branch = '';
        this.repository = undefined;
        this.date = undefined;
        this.diff = new Map<string, number>();
    }
}


export class Git {
    branch: string;

    constructor() {
        this.branch = '';
    }
}

export class FastDeploy {
    enabled: boolean = false;
    image: string | undefined;
    configured: boolean = false;
}

export class Resource {
    name: string;
    namespace: string;
    type: ResourceType;
    status: string;
    reason: string;
    description: string;
    deploy: Deploy;
    helm: Helm;
    git: Git;
    fast_deploy: FastDeploy;

    constructor(type: ResourceType) {
        this.name = '';
        this.namespace = '';
        this.type = type;
        this.status = '';
        this.reason = '';
        this.description = '';
        this.deploy = new Deploy();
        this.helm = new Helm();
        this.git = new Git();
        this.fast_deploy = new FastDeploy();
    }
}

export interface Namespace {
    name: string,
    resources: Resource[],
    status: string,
    creator: string,
    team: string,
    class: string,
    date: Date,
    jenkins: string,
    refresh: {
        branch: string,
        link: string,
    }
    branches: {
        core: string,
        cqs: string,
        ccm: string,
        mys: string,
    },
    requests: {
        count: number,
        last_request: Date | undefined | null,
        period: string
    },
    idle: boolean,
    commit?: string,
    image?: string,
    ingresses?: Array<{ name?: string; labels?: Record<string, string>; hosts?: string[] }>,
    ingressinternals?: Array<{ name?: string; labels?: Record<string, string>; hosts?: string[] }>,
    previewSessionOverlays?: PreviewSessionOverlay[]

}

export interface PreviewSessionWorkload {
    name?: string;
    targetName?: string;
    targetContainer?: string;
    image?: string;
    readyStatus?: string;
    readyReason?: string;
    readyMessage?: string;
    startedAt?: string;
    expiresAt?: string;
}

export interface PreviewSessionOverlay {
    key: string;
    workloads: PreviewSessionWorkload[];
}